var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("bootstrap-box", {
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function() {
            return [
              _c("h3", { staticClass: "box-title" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ]
          },
          proxy: true
        },
        {
          key: "body",
          fn: function() {
            return [
              _c("newsroom-item-editor", {
                ref: "editor",
                attrs: {
                  date: _vm.model.dateValue,
                  title: _vm.model.title,
                  content: _vm.model.content
                },
                on: {
                  "update:date": function($event) {
                    return _vm.$set(_vm.model, "dateValue", $event)
                  },
                  "update:title": function($event) {
                    return _vm.$set(_vm.model, "title", $event)
                  },
                  "update:content": function($event) {
                    return _vm.$set(_vm.model, "content", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _vm._t("action-buttons", null, {
                        isValid: _vm.formIsValid,
                        newsroomItem: _vm.model
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }